import { Type } from 'class-transformer';

export class AAPUserMetricsDetailResultDto {
    processedCount: number;
    deletedCount: number;
    sentToVendorEditCount: number;
    scannedStepCount: number;
    verifyStepCount: number;
    supervisorStepCount: number;
    mismatchCount: number;

    @Type(() => Date)
    processDate: Date;
}
